import React, { useState, useEffect } from "react";
import { connectWisdomWallet } from "../../chain";
import "../../styles/MyTransactions.css";

const MyTransactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [walletAddress, setWalletAddress] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Check wallet connection on component mount
    useEffect(() => {
        const checkWallet = () => {
            const account = localStorage.getItem("user");
            if (account) {
                setWalletAddress(account);
                fetchTransactions(account);
            }
        };
        checkWallet();
    }, []);

    const fetchTransactions = async (address) => {
        setIsLoading(true);
        try {
            // In a real implementation, you would fetch from the blockchain
            // For now, we'll show a placeholder with sample data
            const sampleTransactions = [
                {
                    hash: "0x1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef",
                    from: address,
                    to: "0xWisdomTreasuryAddress",
                    value: "1000000000000000000", // 1 WSD in wei
                    timestamp: new Date().toISOString(),
                    type: "purchase"
                },
                {
                    hash: "0xabcdef1234567890abcdef1234567890abcdef1234567890abcdef1234567890",
                    from: "0xWisdomTreasuryAddress",
                    to: address,
                    value: "500000000000000000", // 0.5 WSD in wei
                    timestamp: new Date(Date.now() - 86400000).toISOString(),
                    type: "reward"
                }
            ];
            
            setTransactions(sampleTransactions);
        } catch (error) {
            console.error("Error fetching transactions:", error);
            setTransactions([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRefresh = async () => {
        if (walletAddress) {
            fetchTransactions(walletAddress);
        }
    };

    return (
        <div className="my-transactions">
            <h1>My Transactions</h1>
            <p>View your past token purchases and rewards.</p>
            
            {!walletAddress ? (
                <div className="wallet-connection">
                    <p>Please connect your wallet to view your transaction history.</p>
                    <button 
                        onClick={async () => {
                            try {
                                const account = await connectWisdomWallet();
                                setWalletAddress(account);
                                fetchTransactions(account);
                            } catch (error) {
                                console.error("Error connecting wallet:", error);
                            }
                        }}
                        className="connect-button"
                    >
                        Connect Wallet
                    </button>
                </div>
            ) : (
                <div className="transactions-content">
                    <div className="wallet-info">
                        <p>Connected wallet: <strong>{walletAddress.substring(0, 6)}...{walletAddress.substring(walletAddress.length - 4)}</strong></p>
                        <button onClick={handleRefresh} disabled={isLoading} className="refresh-button">
                            {isLoading ? "Refreshing..." : "Refresh"}
                        </button>
                    </div>
                    
                    {transactions.length > 0 ? (
                        <div className="transactions-list">
                            <h3>Recent Transactions</h3>
                            {transactions.map((tx, index) => (
                                <div key={index} className="transaction-item">
                                    <div className="transaction-header">
                                        <span className={`transaction-type ${tx.type}`}>
                                            {tx.type === "purchase" ? "Purchase" : "Reward"}
                                        </span>
                                        <span className="transaction-hash">
                                            {tx.hash.substring(0, 6)}...{tx.hash.substring(tx.hash.length - 4)}
                                        </span>
                                    </div>
                                    <div className="transaction-details">
                                        <p><strong>From:</strong> {tx.from.substring(0, 6)}...{tx.from.substring(tx.from.length - 4)}</p>
                                        <p><strong>To:</strong> {tx.to.substring(0, 6)}...{tx.to.substring(tx.to.length - 4)}</p>
                                        <p><strong>Amount:</strong> {parseFloat(tx.value) / 1e18} WSD</p>
                                        <p><strong>Date:</strong> {new Date(tx.timestamp).toLocaleString()}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-transactions">
                            <p>No transactions found.</p>
                            <p>You haven't made any token purchases or received rewards yet.</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MyTransactions;